import PouchDB from 'pouchdb';

import { upsert } from './common';
import { get } from '../utils/api';
import endpoints from '../endpoints';

const PRODUCT_DESCRIPTIONS = 'XXSProductDescription';

class ProductDescription {
  constructor(name) {
    this.db = new PouchDB(name);
  }

  load = (callback) => {
    this.db
      .get(PRODUCT_DESCRIPTIONS)
      .then((doc) => {
        callback(doc);
      })
      .then(() => {})
      .catch(() => {
        callback();
      });
  };

  save = (descriptions, onSuccess) => {
    upsert(this.db, PRODUCT_DESCRIPTIONS, descriptions, onSuccess);
  };

  fetchAndSave = (onSuccess) => get(endpoints.productDescriptions.get)
    .then((response) => this.save(response.data, onSuccess));
}

export default ProductDescription;
